import { useMemo, useState } from 'react'
import * as SystemHttp from '../../../../services/api/https/system/system.http'
import { getGeocode } from '../../../../services/Maps'
import { errorHandler } from '../../../../services/util/error.service'
import * as TpHttp from '../../../../services/api/https/settings/tp.http'
import * as UserHttp from '../../../../services/api/https/settings/user.http'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  LOADING_EDIT: 'Adquirindo informações para edição',
  LOADING_UF: 'Carregando unidades federativas',
  LOADING_CITIES: 'Carregando cidades',
  LOADING_COORDINATES: 'Adquirindo coordenadas do endereço',
  LOADING_CNPJ_DATA: 'Adquirindo dados do CNPJ',
  LOADING_CITY_COORDINATES: 'Adquirindo cidade e coordenadas',
  SAVE_NEW: 'Salvando novo TP',
  SUCCESS: 'TP cadastrado',
  COPIED: 'Token copiado',
}

const INITIAL_TP = {
  id: null,
  name: '',
  actived: true,
  show_vehicles_by: '',
  assoc_companies: [],
  assoc_emissores: [],
  opCenterDefault: null,
  expedicao_gerar_picking_completo: false,
  entregas_picking_concluido_carregamento: false,
  bloquear_envio_rota_sem_pallet_carregado: false,
  mfa_habilitado: false,
  reentrega_exige_ocorrencia: false,
  baixa_manual_exige_documentacao: false,
  logo_img: null,
  permissions: [],
  cnpj: '',
  razao_social: '',
  inscricao_estadual: '',
  cep: '',
  phone: '',
  address: '',
  district: '',
  number: '',
  latitude: 0,
  longitude: 0,
  city_id: 0,
  total_tpdrive_licenses: 0,
  total_tpdrive_licenses_enabled: 0,
  companies_limit: 0,
  companies_limit_enabled: 0,
  token_robot: '',
  tp_user_admin: null,
  token_grafos: null,
  grafos_user_id: null,
  grafos_ativo: false,
  show_release_status: false,
}

export const INITIAL_STATE = {
  tp: {
    ...INITIAL_TP,
  },
  actived_index: 0,
  ufs: [],
  selectedUf: 0,
  selectedCity: 0,
  cities: [],
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  updatingAssoc: false,
  usersOfTp: [],
  selectedUserAdmin: null,
  selectedGrafosUser: null,
}

export const showVehicleBy = [
  { label: 'By Description', value: 'By Description' },
  { label: 'By Badge', value: 'By Badge' },
]

function generateRandomToken(byteLength = 32) {
  const bytes = window.crypto.getRandomValues(new Uint8Array(byteLength))
  return Array.from(bytes)
    .map(b => b.toString(16).padStart(2, '0'))
    .join('')
}

export default function useModalTp() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      // Actions
      resetError() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      async onInit(data, operationsCenters) {
        try {
          setState(prevState => ({
            ...prevState,
            tp: {
              ...INITIAL_TP,
              ...data,
              opCenterDefault: data.operation_center_default_id
                ? operationsCenters
                    .map(op => ({
                      id: op.id,
                      name: op.name,
                    }))
                    .find(op => data.operation_center_default_id === op.id)
                : null,
              show_vehicles_by: showVehicleBy.find(s => s.value === data.show_vehicles_by),
              permissions: data.permissions,
            },
            selectedUf: 0,
            selectedCity: 0,
            cities: [],
            usersOfTp: [],
            selectedUserAdmin: null,
            selectedGrafosUser: null,
            loadingMessage: LOAD_MESSAGE.LOADING_EDIT,
          }))

          const users = await UserHttp.getActiveUsersByTp(data.id)

          setState(prevState => ({
            ...prevState,
            usersOfTp: users,
            selectedUserAdmin: users.find(u => u.id === data.tp_user_admin) || null,
            selectedGrafosUser: users.find(u => u.id === data.grafos_user_id) || null,
          }))
        } catch (error) {
          setState(prevState => ({
            ...prevState,
            errorMessage: errorHandler(error),
            loadingMessage: LOAD_MESSAGE.NONE,
          }))
        }
      },

      async onBtnSalvarClicked(tpSave) {
        try {
          const {
            id,
            name,
            actived,
            show_vehicles_by,
            opCenterDefault,
            expedicao_gerar_picking_completo,
            entregas_picking_concluido_carregamento,
            bloquear_envio_rota_sem_pallet_carregado,
            mfa_habilitado,
            reentrega_exige_ocorrencia,
            baixa_manual_exige_documentacao,
            address,
            district,
            number,
            city_id,
            latitude,
            longitude,
            cnpj,
            razao_social,
            inscricao_estadual,
            cep,
            phone,
            total_tpdrive_licenses,
            companies_limit,
            tp_user_admin,
            grafos_user_id,
            token_grafos,
            grafos_ativo,
            show_release_status,
          } = tpSave

          if (name.trim().length < 3) {
            throw new Error('Nome Operador Logístico Incorreto')
          }
          if (grafos_ativo && (!token_grafos || !grafos_user_id)) {
            throw new Error(
              'Para ativar a integração com a Grafos, gere o token e selecione o usuário responsável.',
            )
          }
          const { tp } = await TpHttp.saveTp({
            id,
            name,
            actived,
            show_vehicles_by: show_vehicles_by.value,
            operation_center_default_id: opCenterDefault ? opCenterDefault.id : opCenterDefault,
            expedicao_gerar_picking_completo,
            entregas_picking_concluido_carregamento,
            bloquear_envio_rota_sem_pallet_carregado,
            mfa_habilitado,
            reentrega_exige_ocorrencia,
            baixa_manual_exige_documentacao,
            address,
            district,
            number,
            city_id,
            latitude,
            longitude,
            cnpj,
            razao_social,
            inscricao_estadual,
            cep,
            phone,
            total_tpdrive_licenses,
            companies_limit,
            tp_user_admin,
            grafos_user_id,
            token_grafos,
            grafos_ativo,
            show_release_status: !!show_release_status,
          })
          setState(prevState => ({
            ...prevState,
            tp: { ...prevState.tp, ...tp },
            loadingMessage: LOAD_MESSAGE.SUCCESS,
          }))
        } catch (error) {
          setState(prevState => ({ ...prevState, errorMessage: errorHandler(error) }))
        }
      },

      async onAssocTpEmpresaClick(item, { active, obrigar_carregar, envio_picking_conferido }) {
        try {
          const updatedItem = {
            ...item,
            active: active ? 1 : 0,
            obrigar_carregar: obrigar_carregar ? 1 : 0,
            envio_picking_conferido: envio_picking_conferido ? 1 : 0,
          }

          setState(prev => ({
            ...prev,
            updatingAssoc: true,
          }))

          const { assoc_companies, companies_limit_enabled } =
            await TpHttp.saveAssocTpEmpresa(updatedItem)

          setState(prev => ({
            ...prev,
            tp: {
              ...prev.tp,
              assoc_companies,
              companies_limit_enabled,
            },
            updatingAssoc: false,
          }))
        } catch (e) {
          setState(prevState => ({
            ...prevState,
            errorMessage: errorHandler(e),
            updatingAssoc: false,
          }))
        }
      },

      async onAssocTpEmissorClick(item, checked) {
        try {
          item.active = checked
          const assocEmissores = await TpHttp.saveAssocTpEmissor(item)

          setState(prev => {
            prev.tp.assoc_emissores = assocEmissores
            return { ...prev }
          })
        } catch (e) {
          setState(prevState => ({ ...prevState, errorMessage: errorHandler(e) }))
        }
      },

      async onAssocTpPermissionClick(item, checked, tpId) {
        try {
          item.selected = checked

          const assocPermissionTp = await TpHttp.saveAssocTpPermission(tpId, item)
          setState(prev => {
            prev.tp.permissions = assocPermissionTp
            return { ...prev }
          })
        } catch (e) {
          setState(prevState => ({ ...prevState, errorMessage: errorHandler(e) }))
        }
      },

      async onUploadCompleted(file_name, tpId) {
        try {
          await TpHttp.saveTpLogoPath(tpId, file_name)
          setState(prev => ({ ...prev, tp: { ...prev.tp, logo_img: file_name } }))
        } catch (error) {
          setState(prevState => ({ ...prevState, errorMessage: errorHandler(error) }))
        }
      },

      onTabChange(index) {
        setState(prevState => ({ ...prevState, actived_index: index }))
      },

      onCnpjChange(cnpj, tpId) {
        setState(prevState => ({ ...prevState, tp: { ...prevState.tp, cnpj } }))

        if (cnpj.length === 14)
          setState(prevState => ({
            ...prevState,
            loadingMessage: LOAD_MESSAGE.LOADING_CNPJ_DATA,
          }))
      },

      onEstadoChange(uf) {
        setState(prevState => {
          prevState.selectedUf = uf
          prevState.loadingMessage = LOAD_MESSAGE.LOADING_CITIES
          return { ...prevState }
        })
      },

      onCityChange(name, value) {
        setState(prevState => {
          prevState.selectedCity = value
          prevState.tp[name] = value.id
          return { ...prevState }
        })
      },

      onSearchCoordinatesClick(e, selectedCity) {
        e.preventDefault()
        if (selectedCity !== 0)
          setState(prevState => ({
            ...prevState,
            loadingMessage: LOAD_MESSAGE.LOADING_COORDINATES,
          }))
        else setState(prevState => ({ ...prevState, errorMessage: 'Selecione a cidade' }))
      },

      onCoordinatesChange(coordinates) {
        setState(prevState => ({
          ...prevState,
          tp: {
            ...prevState.tp,
            latitude: coordinates.latitude,
            longitude: coordinates.longitude,
          },
        }))
      },

      fetchCoordinates(numero, endereco, bairro, cidade) {
        getGeocode(`${endereco}, ${numero}, ${bairro}, ${cidade.name}-${cidade.uf_id}, Brasil`)
          .then(res => {
            if (!res.lng) throw new Error('Endereço não encontrado')
            const { lat, lng } = res

            setState(prevState => ({
              ...prevState,
              tp: { ...prevState.tp, latitude: lat, longitude: lng },
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(err => {
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
      },

      fetchCnpjData(cnpj) {
        SystemHttp.getCnpjDataFocusNfe(cnpj)
          .then(async res => {
            setState(prevState => ({
              ...prevState,
              tp: {
                ...prevState.tp,
                razao_social: String(res.razao_social || prevState.tp.razao_social || '')
                  .toUpperCase()
                  .slice(0, 255),
                cep: String(res.endereco.cep || prevState.tp.cep || '').replace(/\D/g, ''),
                city_id: parseInt(res.endereco.codigo_ibge),
                address: res.endereco.logradouro,
                district: res.endereco.bairro,
                number: res.endereco.numero,
              },
              selectedCity: {
                id: parseInt(res.endereco.codigo_ibge),
                name: res.endereco.nome_municipio,
              },
              selectedUf: prevState.ufs.find(uf => uf.uf === res.endereco.uf),
              loadingMessage: LOAD_MESSAGE.LOADING_CITY_COORDINATES,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      onInputChange(name, value) {
        setState(prevState => {
          prevState.tp[name] = value
          return { ...prevState }
        })
      },

      fetchUFs(ufId = null) {
        SystemHttp.getUfs()
          .then(ufs => {
            if (ufId)
              setState(prevState => ({
                ...prevState,
                ufs: ufs,
                selectedUf: ufs.find(uf => uf.id === Number(ufId)),
                loadingMessage: LOAD_MESSAGE.LOADING_CITIES,
              }))
            else
              setState(prevState => ({ ...prevState, ufs: ufs, loadingMessage: LOAD_MESSAGE.NONE }))
          })
          .catch(err => setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })))
      },

      fetchCities(ufId, city_id = null) {
        SystemHttp.getCities(ufId)
          .then(cities => {
            if (city_id) {
              setState(prevState => ({
                ...prevState,
                cities: cities,
                selectedCity: cities.find(city => city.id === Number(city_id)),
                loadingMessage: LOAD_MESSAGE.NONE,
              }))
            } else
              setState(prevState => ({
                ...prevState,
                cities: cities,
                loadingMessage: LOAD_MESSAGE.NONE,
              }))
          })
          .catch(err => setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })))
      },

      async onBtnGerarTokenClicked(tp) {
        try {
          const token = await TpHttp.gerarTokenRoboXml(tp.id)
          tp.token_robot = token
          setState(prevState => ({
            ...prevState,
            tp,
            loadingMessage: LOAD_MESSAGE.SUCCESS,
          }))
        } catch (error) {
          setState(prevState => ({ ...prevState, errorMessage: errorHandler(error) }))
        }
      },

      onBtnGerarTokenGrafosClicked() {
        const token = generateRandomToken()
        setState(prevState => ({
          ...prevState,
          tp: { ...prevState.tp, token_grafos: token },
        }))
      },

      onBotaoCopiarTokenClicked(token) {
        navigator.clipboard.writeText(token).then(
          () => {
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.COPIED,
            }))
          },
          () => {
            setState(prevState => ({
              ...prevState,
              errorMessage: 'Erro ao copiar token',
            }))
          },
        )
      },

      onChangeUserAdmin(user) {
        setState(s => ({
          ...s,
          selectedUserAdmin: user,
          tp: { ...s.tp, tp_user_admin: user ? user.id : null },
        }))
      },

      onChangeGrafosUser(user) {
        setState(s => ({
          ...s,
          selectedGrafosUser: user,
          tp: { ...s.tp, grafos_user_id: user ? user.id : null },
        }))
      },

      onChangeGrafosAtivo(checked) {
        setState(s => ({
          ...s,
          tp: { ...s.tp, grafos_ativo: checked },
        }))
      },

      onChangeShowReleaseStatus(checked) {
        setState(s => ({
          ...s,
          tp: { ...s.tp, show_release_status: checked },
        }))
      },
    }
  }, [])

  return { state, localDispatch }
}
